import { render } from "./HotelnformationModal.vue?vue&type=template&id=6cfa7423&scoped=true"
import script from "./HotelnformationModal.vue?vue&type=script&lang=js"
export * from "./HotelnformationModal.vue?vue&type=script&lang=js"

import "./HotelnformationModal.vue?vue&type=style&index=0&id=6cfa7423&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfa7423"]])

export default __exports__